import React, { useState } from 'react'
import Carousel, { Modal, ModalGateway } from 'react-images'
import {
  CFIcon,
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  LocationSelect,
  MobileScreen,
} from 'components'
import { headerBg, logo, mobileLogo, logoTitle, viewMenu } from 'images'
import { dispatch } from 'store'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/8GFwb8UTNOQ2rbtqc9kk/locations/Y7GXtSFgqD6z5v9Jpd8q'

const images = []

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <MobileScreen>
        <CFView
          column
          center
          w="100%"
          pv="8px"
          bg="rgba(0, 0, 0, 0.8)"
          boxShadow="0px 2px 4px rgba(0, 0, 0, 0.25)"
        >
          <CFImage w="50%" src={mobileLogo} alt="Bruncheria Logo" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView w="100%" zIndex={98} bg="white" pv="5px">
          <CFView row justifyBetween alignCenter w="100%" maxWidth="1400px">
            <CFImage
              pt="5px"
              ml="50px"
              w="220px"
              src={logo}
              alt="Bruncheria Logo"
              zIndex={98}
            />
            <CFView mr="50px" bold color="#E68309">
              <CFIcon
                icon="phone"
                color="#E68309"
                fontSize={22}
                mr="10px"
                mt="2px"
              />
              (236) 428-1709
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
      <ModalGateway>
        {showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  )
}
